"use strict";

angular.module('config', [])
  .provider('ConfigEnvironment', function() {

    window.console.log = function(){};

    this.configuration = {
      'env': 'prod',
      'greenback': 'https://greenback-api.startupmedia.com/',
      'advertising': 'https://benefits-api.startupmedia.com/',
      'cdn':'//cdn.startupmedia.com/',
      'nonselective_sponsors': [14],
      'generic_sponsor_id': 22,
      'startup_sponsor_id': 14,
      'inapp_portal': 'http://portals.gogreenback.com/',
      'env_cdn': '//cdn.startupmedia.com/'
    };

    this.$get = () => this;

    this.setConfiguration = function(key, value) {
      return this.configuration[key] = value;
    }

    this.getConfiguration = function(key) {
      return this.configuration[key];
    }

    this.getApiUrl = function(name) {
      return this.configuration[name] + 'api';
    }
  });
;



// WEBPACK FOOTER //
// ./js/config/config.production.js